// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'id',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'keyword',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'keyword_en',
    Object: 'value',
    label: '',
    width: '150'
  }]
}
